import axios from "axios";
import { API_BASE_URL } from "../../axiosConfig/apiUrl";
import {
  ICancelMemberSubscription,
  ISubscription,
  IUpdateSubscriptionPaymentMethod,
} from "../../utility/types/subscriptionType";

export const submitSubscribeUser = async (payload: ISubscription) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/subscription`,
      { payload },
      { withCredentials: true }
    );
    return response.data.subscription;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error(
        "Unknown Error Occurred While Making Request To Subscribe User"
      );
    }
  }
};

export const submitReSubscribeUser = async (payload: ISubscription) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/subscription/reactivate`,
      { payload },
      { withCredentials: true }
    );

    return response.data.subscription;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error(
        "Unknown Error Occurred While Request To Re-Subscribe User"
      );
    }
  }
};

export const submitGetUserSubscription = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/subscription`, {
      withCredentials: true,
    });
    return response.data.subscription;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Unknown Error Occurred While Making Request To API");
    }
  }
};

export const submitCreateSetUpIntent = async (userId: string) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/payment/setup-intent`,
      { userId },
      { withCredentials: true }
    );
    return response.data.clientSecret;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Unknown Error Occurred While Making Request To API");
    }
  }
};

export const submitUpdatePaymentMethod = async (
  payload: IUpdateSubscriptionPaymentMethod
) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/subscription/update-payment-method`,
      { payload },
      { withCredentials: true }
    );
    return response.data.updatePayment.updateSubscription;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Unknown Error Occurred While Making Request To API");
    }
  }
};

export const submitCancelMembership = async (
  payload: ICancelMemberSubscription
) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/subscription/cancel`,
      { payload },
      { withCredentials: true }
    );
    return response.data.subscriptionCancel;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Unknown Error Occurred While Making Request To API");
    }
  }
};
